import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ROUTES } from '@/constants/routes.constants';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
      <Typography variant="h1" color="primary">
        404
      </Typography>
      <Typography variant="h5">{t('errors.notFoundTitle')}</Typography>
      <Typography variant="body1" color="text.secondary">
        {t('errors.notFoundDescription')}
      </Typography>
      <Button component={RouterLink} to={ROUTES.ROOT} variant="contained">
        {t('errors.backToHome')}
      </Button>
    </Stack>
  );
}
